import React, { useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import MainLayoutTemplate from '../layout/MainLayoutTemplate/MainLayoutTemplate';
import MessagingPage from '../newsintelligence/MainHeader/Messaging/MessagingPage';
import { APP_NAME } from '../config/branding';
import { buildSigninUrl, stashPendingVerificationEmail } from '../newsintelligence/support/openDiscussions/auth/guestAuth';
import { MESSAGES_APP_BASE, MESSAGES_SIDEBAR_ITEMS } from './messagesSidebar';
import '../newsintelligence/support/openDiscussions/styles/OpenDiscussions.css';
import '../newsintelligence/MainHeader/Messaging/Messaging.css';
import './MessagesApp.css';
import { useStandaloneMobileThreadViewport } from './useStandaloneMobileThreadViewport';

const baseUrl = process.env.REACT_APP_BASE_URL || '';

function useMessagesShellProfile(shell) {
  const { profile, profileResolved, profileAvatarSrc, isMobileLayout } = shell;
  const navigate = useNavigate();
  const isEmailVerificationPending = profileResolved && profile?.emailNotVerified === true;

  useEffect(() => {
    if (!isEmailVerificationPending) return undefined;
    let cancelled = false;
    if (profile?.email) stashPendingVerificationEmail(profile.email);
    (async () => {
      try {
        await fetch(`${baseUrl}/api/signout`, {
          method: 'POST',
          credentials: 'include',
          headers: { 'Content-Type': 'application/json' },
        });
      } catch {
        /* ignore */
      }
      if (!cancelled) {
        navigate(buildSigninUrl({ mode: 'signin', returnTo: MESSAGES_APP_BASE }));
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [isEmailVerificationPending, profile?.email, navigate]);

  return { profile, profileAvatarSrc, isMobileLayout };
}

function MessagesWorkspace({ shell }) {
  const { profile, profileAvatarSrc, isMobileLayout } = useMessagesShellProfile(shell);
  useStandaloneMobileThreadViewport(isMobileLayout);

  return (
    <MessagingPage
      mobileFullscreen={isMobileLayout}
      viewerUserId={profile?.userId}
      viewerUser={{
        userId: profile?.userId,
        name: profile?.name,
        profilePictureUrl: profileAvatarSrc,
        handle: profile?.handle,
        profileMode: profile?.profileMode,
      }}
      standalone
    />
  );
}

export default function MessagesApp() {
  const navigate = useNavigate();

  const openAccountSettings = useCallback(() => {
    navigate('/d/profile');
  }, [navigate]);

  useEffect(() => {
    document.title = `Messages · ${APP_NAME}`;
    return () => {
      document.title = APP_NAME;
    };
  }, []);

  return (
    <MainLayoutTemplate
      layoutClassName="posts-page-layout--messages-app"
      mainClassName="messaging-page-shell-main"
      sidebarItems={MESSAGES_SIDEBAR_ITEMS}
      showHeaderSearch={false}
      returnTo={MESSAGES_APP_BASE}
      messagesStandalone
      onManageProfileClick={openAccountSettings}
    >
      {(shell) => <MessagesWorkspace shell={shell} />}
    </MainLayoutTemplate>
  );
}
